<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@codeGenReportDialog-Title">Code Generation Report</h2>
		<button mat-icon-button>
			<mat-icon class="color-primary" (click)="onCloseDialog()" data-automation-id="code-gen-report-close-button"
				>close</mat-icon
			>
		</button>
	</div>

	<mat-dialog-content class="drawer-dialog-content">
		@if (isHaspCodeGenFeatureEnabled) {
			<h3 class="drawer-dialog-content-header" i18n="@@codeGenReportDialog-type">Type</h3>
			<mat-form-field subscriptSizing="dynamic" class="fix-full-width" appearance="outline">
				<mat-select
					class="filter-slim-top"
					name="codeType"
					placeholder="Code Type"
					(selectionChange)="onSelectedCodeTypeEvent($event.value)"
					data-automation-id="code-type-picker"
				>
					<mat-option value="1" data-automation-id="code-type-access">
						<div class="flex-row-center-div">
							<mat-icon
								class="capabilities-icon"
								svgIcon="sl-access-code-gen"
								matTooltip="{{ accessCodeTooltip }}"
							></mat-icon>
							<div i18n="@@codeGenReportDialog-accessType">Access</div>
						</div>
					</mat-option>
					<mat-option value="2" data-automation-id="code-type-hasp">
						<div class="flex-row-center-div">
							<mat-icon
								class="capabilities-icon"
								svgIcon="sl-hasp-code-gen"
								matTooltip="{{ haspCodeTooltip }}"
							></mat-icon>
							<div i18n="@@codeGenReportDialog-haspType">Hasp</div>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-divider></mat-divider>
		}

		<h3 class="drawer-dialog-content-header" i18n="@@codeGenReportDialog-devices">Devices</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				[allDropdownOptions]="deviceOptions"
				[filterOnField]="'serialNumber'"
				data-automation-id="devices-typeahead"
				[placeholderText]="this.deviceMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-lock'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="deviceId"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('device', $event)"
				(searchInputChanged)="onSearchInput('device', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		@if (isCareCompany) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientFirstName">Client First Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="first-name-typeahead"
						[allDropdownOptions]="firstNames"
						[filterOnField]="'firstName'"
						[placeholderText]="this.firstNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="firstName"
						[initiallySelectedIdField]="'firstName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('firstName', $event)"
						(searchInputChanged)="onSearchInput('firstName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientLastName">Client Last Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="last-name-typeahead"
						[allDropdownOptions]="lastNames"
						[filterOnField]="'lastName'"
						[placeholderText]="this.lastNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="lastName"
						[initiallySelectedIdField]="'lastName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('lastName', $event)"
						(searchInputChanged)="onSearchInput('lastName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientIdn">Client IDN</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="client-idn-typeahead"
						[allDropdownOptions]="clientIdns"
						[filterOnField]="'idn'"
						[placeholderText]="this.clientIdnMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="clientIdn"
						[initiallySelectedIdField]="'idn'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('clientIdn', $event)"
						(searchInputChanged)="onSearchInput('clientIdn', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>
		}

		@if (this.isSentrilock) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@codeGenReportDialog-deviceOwner">Device Owners</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="device-owners-typeahead"
						[allDropdownOptions]="this.deviceOwnerOptions"
						[filterOnField]="'name'"
						[placeholderText]="this.deviceOwnerMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-nav-work'"
						[initiallySelectedItemIds]="this.deviceOwnerId"
						[initiallySelectedIdField]="'id'"
						[minCharactersForSearch]="3"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceOwner', $event)"
						(searchInputChanged)="onSearchInput('deviceOwner', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
				<mat-divider></mat-divider>
			</div>
		}

		<h3 class="drawer-dialog-content-header" i18n="@@codeGenReportDialog-genereatedBy">Generated By</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="generated-by-typeahead"
				[allDropdownOptions]="this.generatedByUserOptions"
				[filterOnField]="'displayName'"
				[placeholderText]="this.generatedByMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[initiallySelectedItemIds]="this.generatedById"
				[minCharactersForSearch]="3"
				[initiallySelectedIdField]="'id'"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('generatedBy', $event)"
				(searchInputChanged)="onSearchInput('generatedBy', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@codeGenReportDialog-assignedTo">Assigned To</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="assigned-to-typeahead"
				[allDropdownOptions]="this.assignedToUserOptions"
				[filterOnField]="'displayName'"
				[placeholderText]="this.userNameOrEmailPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[initiallySelectedItemIds]="this.assignedToId"
				[minCharactersForSearch]="3"
				[initiallySelectedIdField]="'id'"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('assignedTo', $event)"
				(searchInputChanged)="onSearchInput('assignedTo', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@codeGenReportDialog-dateGenerated">Date Generated</h3>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@codeGenReportDialog-startDateGenerated">Start (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateGeneratedStartPicker"
					placeholder="Start (optional)"
					i18n-placeholder="@@codeGenReportDialog-chooseStartDateGenerated"
					(dateChange)="onDateGeneratedStartDateChanged($event)"
					[ngModel]="this.codeGenReportFilters.dateGeneratedStartDate"
					data-automation-id="start-date-generated-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateGeneratedStartPicker"
					data-automation-id="start-date-generated-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateGeneratedStartPicker data-automation-id="start-date-generated-datepicker"></mat-datepicker>
			</mat-form-field>

			<div style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px">To</div>

			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@codeGenReportDialog-endDateGenerated">End (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateGeneratedEndPicker"
					placeholder="End (optional)"
					i18n-placeholder="@@codeGenReportDialog-ChooseEndDateGenerated"
					(dateChange)="onDateGeneratedEndDateChanged($event)"
					[ngModel]="this.codeGenReportFilters.dateGeneratedEndDate"
					data-automation-id="end-date-generated-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateGeneratedEndPicker"
					data-automation-id="end-date-generated-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateGeneratedEndPicker data-automation-id="end-date-generated-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@codeGenReportDialog-dateValid">Date Valid</h3>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@codeGenReportDialog-startDateValid">Start (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateValidStartPicker"
					placeholder="Start (optional)"
					i18n-placeholder="@@codeGenReportDialog-chooseStartDateValid"
					(dateChange)="onDateValidStartDateChanged($event)"
					[ngModel]="this.codeGenReportFilters.dateValidStartDate"
					data-automation-id="start-date-valid-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateValidStartPicker"
					data-automation-id="start-date-valid-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateValidStartPicker data-automation-id="start-date-valid-datepicker"></mat-datepicker>
			</mat-form-field>

			<div style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px">To</div>

			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@codeGenReportDialog-endDateValid">End (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateValidEndPicker"
					placeholder="End (optional)"
					i18n-placeholder="@@codeGenReportDialog-ChooseEndDateValid"
					(dateChange)="onDateValidEndDateChanged($event)"
					[ngModel]="this.codeGenReportFilters.dateValidEndDate"
					data-automation-id="end-date-valid-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateValidEndPicker"
					data-automation-id="end-date-valid-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateValidEndPicker data-automation-id="end-date-valid-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				i18n="@@codeGenReportDialog-closeWindow"
				(click)="onCloseDialog()"
				data-automation-id="code-gen-report-cancel-button"
			>
				Cancel
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				(click)="onGenerateReport()"
				data-automation-id="code-gen-report-code-gen-button"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
